import { useMemo } from 'react';

import type { MenuItem } from '@/consts/navigation';
import { useNavigationContext } from '@/features/navigation/context/NavigationContext';

export const useActiveMenuItem = (item: MenuItem) => {
  const { isRouteActive, hasActiveChild } = useNavigationContext();

  return useMemo(() => {
    const hasChildren = Boolean(item.children?.length);
    const hasRoute = Boolean(item.to?.length);
    const isUtilitySection = item.text === 'navigation.recent.title' || item.text === 'navigation.favorites.title';
    const hasActiveChildren = !isUtilitySection && hasActiveChild(item.children);
    const isDirectlyActive = !hasChildren && isRouteActive(item.to);
    const isActiveInCollapsedNav = isDirectlyActive || hasActiveChildren;

    return {
      hasChildren,
      hasRoute,
      hasActiveChildren,
      isDirectlyActive,
      isActiveInCollapsedNav,
      isUtilitySection
    };
  }, [item, isRouteActive, hasActiveChild]);
};
